import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { useLocation } from "react-router-dom";

/** Drives the left IconRail hover blob from outside the rail (e.g. Home quick links). */
export interface NavRailPreviewState {
  navId: string;
}

interface NavRailPreviewContextValue {
  preview: NavRailPreviewState | null;
  setPreview: (preview: NavRailPreviewState | null) => void;
}

const NavRailPreviewContext = createContext<NavRailPreviewContextValue | null>(
  null,
);

export function NavRailPreviewProvider({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const [preview, setPreviewState] = useState<NavRailPreviewState | null>(
    null,
  );
  const setPreview = useCallback((next: NavRailPreviewState | null) => {
    setPreviewState(next);
  }, []);

  useEffect(() => {
    setPreviewState(null);
  }, [pathname]);
  const value = useMemo(
    () => ({ preview, setPreview }),
    [preview, setPreview],
  );
  return (
    <NavRailPreviewContext.Provider value={value}>
      {children}
    </NavRailPreviewContext.Provider>
  );
}

export function useNavRailPreviewOptional(): NavRailPreviewContextValue | null {
  return useContext(NavRailPreviewContext);
}
